module.exports = __webpack_public_path__ + "media/theme/tutorial__psn--4--create-47e2d1b0.jpg";